import React, { useState } from "react";
import axios from "axios";

const WalletPage = () => {
  const [amount, setAmount] = useState("");
  const [showUpload, setShowUpload] = useState(false);
  const [screenshot, setScreenshot] = useState(null);
  const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

  const handleOk = () => {
    if (!amount || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }
    setShowUpload(true);
  };

  const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!screenshot) {
      alert("Please upload payment screenshot");
      return;
    }

    const userId = localStorage.getItem("UserId");
    const name = localStorage.getItem("username");

    if (!userId) {
      alert("User not logged in");
      return;
    }

    const formData = new FormData();
    formData.append("amount", amount);
    formData.append("name", name);
    formData.append("order_id", `ORD-${Date.now()}`);
    formData.append("user_message", "Paid via QR");
    formData.append("screenshot", screenshot);

    try {
      setLoading(true);

      await axios.post(
        `${process.env.REACT_APP_API}/wallet/addfundamount/${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Fund request submitted. Waiting for admin approval.");

      // reset
      setAmount("");
      setScreenshot(null);
      setShowUpload(false);

    } catch (error) {
      console.error(error);
      alert("Failed to submit fund request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow p-4 col-md-6 mx-auto">

        <h4 className="mb-3 text-center">Add Fund</h4>

        {/* QR IMAGE */}
         <div className="text-center mb-4">
        <img
          src="/qr.jpeg"
          alt="Payment QR"
          style={{
            width: "220px",
            border: "1px solid #ddd",
            padding: "10px",
            cursor: "zoom-in"
          }}
          onClick={() => setPreviewImage("/qr.jpeg")}
        />
        <p className="mt-2 text-muted">
          Scan this QR and send the amount
        </p>
      </div>
 {previewImage && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.6)"
          }}
          onClick={() => setPreviewImage(null)}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img
                  src={previewImage}
                  alt="Zoomed QR"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      )}

        {/* Amount Input */}
        <div className="mb-3">
          <label className="form-label">Enter Amount</label>
          <input
            type="number"
            className="form-control"
            placeholder="₹ Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        {/* OK Button */}
        {!showUpload && (
          <button className="btn btn-primary w-100" onClick={handleOk}>
            OK
          </button>
        )}

        {/* Screenshot Upload */}
        {showUpload && (
          <>
            <div className="mb-3 mt-3">
              <label className="form-label">Upload Payment Screenshot</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>

            <button
              className="btn btn-success w-100"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Fund Request"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default WalletPage;






// import React, { useEffect, useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faWallet, faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import axios from 'axios';

// const WalletPage = () => {
//   const [balance, setBalance] = useState(0.0);
//   const [paymentState, setPaymentState] = useState('');
//   const [merchantOrderId, setMerchantOrderId] = useState('');
//   const [message, setMessage] = useState('');
//   const [paymentUrl, setPaymentUrl] = useState('');
//   const [fundpage, setFundpage] = useState(false);
//   const [amount, setAmount] = useState('');
//   const [selectedAmount, setSelectedAmount] = useState('');
//   const [searchParams] = useSearchParams();
//   const OrderId = searchParams.get("orderId");
//   const navigate = useNavigate();

//   const transactions = [
//     { id: 1, type: 'credit', amount: 500, description: 'Course Payment Received', date: '2025-07-10' },
//     { id: 2, type: 'debit', amount: 250, description: 'Exam Fee Paid', date: '2025-07-08' },
//     { id: 3, type: 'credit', amount: 1000, description: 'Referral Bonus', date: '2025-07-05' },
//   ];

//   useEffect(() => {
//     fetchData();

//     // Load payment status from localStorage if exists
//     const savedStatus = localStorage.getItem("paymentStatus");
//     if (savedStatus) {
//       setPaymentState(savedStatus);
//       localStorage.removeItem("paymentStatus");
//     }
//   }, []);

//   const fetchData = async () => {
//     const userId = localStorage.getItem('UserId');
//     if (!userId) return;

//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/wallet/getwalletamount/${userId}`
//       );
//       setBalance(response.data.balance);
//     } catch (error) {
//       console.error("Failed to fetch wallet balance:", error);
//     }
//   };

// const addammount = async (amountValue) => {
//     const parsedAmount = parseFloat(amountValue);
//     if (!parsedAmount || isNaN(parsedAmount) || parsedAmount <= 0) {
//         alert('Please enter a valid positive amount');
//         return;
//     }

//     try {
//         const userId = localStorage.getItem('UserId');
//         if (!userId) {
//             alert('User not logged in.');
//             return;
//         }

//         const response = await axios.put(
//             `${process.env.REACT_APP_API}/wallet/addamount/${userId}`,
//             { amount: parsedAmount }
//         );

//         alert(response.data.message || 'Amount added successfully');
//         fetchData();
//     } catch (error) {
//         console.error('Failed to add amount:', error);
//         alert(error.response?.data?.error || 'Failed to add amount. Please try again.');
//     }
// };


  

//   const getAuthToken = async () => {
//     try {
//       const response = await axios.post(`https://ramjitrust.org:4000/payment/get-auth-token`);
//       return response.data.access_token;
//     } catch (error) {
//       console.error("Error fetching auth token:", error);
//       setMessage("Failed to initialize payment system");
//       return null;
//     }
//   };

//   const generateOrderId = () => {
//     const timestamp = Date.now();
//     const random = Math.floor(Math.random() * 10000);
//     return `ORD_${timestamp}_${random}`.slice(0, 63);
//   };
 
// const paymentAmount = parseFloat(amount); // convert to number


//   const initiatePayment = async () => {
//      const userId = localStorage.getItem("UserId");
// const userName = localStorage.getItem("username") || "Unknown";
//     try {
//         const token = await getAuthToken();
//         if (!token) return;

//         const generatedOrderId = generateOrderId();
//         setMerchantOrderId(generatedOrderId);

//         // Retrieve required values from your React state (not localStorage)
//         const userId = localStorage.getItem("UserId");         // replace with your state or props
//         const userName = localStorage.getItem("username");     // replace with your state or props
//         const amount = paymentAmount;                      // use fixed or from formData/state

//         // 1️⃣ Store pending payment in DB before payment
//         const payload = {
//             userId,
//             userName,
//             orderId: generatedOrderId,
//             amount,
//             paymentStatus: "PENDING", // explicitly mark as pending
//         };

//         await axios.post(`https://ramjitrust.org:4000/form/store`, payload);

//         // 2️⃣ Initiate payment
//         const response = await axios.post(
//             `https://ramjitrust.org:4000/payment/initiate-payment`,
//             {
//                 amount: parseFloat(amount),
//                 merchantOrderId: generatedOrderId,
//                 token,
//             }
//         );

//         // 3️⃣ Redirect user to payment URL
//         setPaymentUrl(response.data.redirectUrl);
//         window.location.href = response.data.redirectUrl;
//     } catch (error) {
//         console.error("Payment initiation failed:", error);
//         setMessage("Failed to initiate payment. Please try again.");
//     }
// };




//   const handleAmountClick = (amt) => {
//     setAmount(amt);
//     setSelectedAmount(amt);
//   };

//   const handleCustomAmount = () => {
//     setSelectedAmount('custom');
//     setAmount('');
//   };

//   const handleSubmitdonate = async (e) => {
//     e.preventDefault();
//     if (!amount || isNaN(amount)) {
//       alert('Please enter a valid amount');
//       return;
//     }
//     await initiatePayment();
//   };

   

//   return (
//     <div className="container mt-4">
//       <h2>
//         <FontAwesomeIcon icon={faWallet} className="text-primary me-2" />
//         Wallet
//       </h2>

//       {paymentState && (
//         <div className={`alert mt-3 ${
//           paymentState === "COMPLETED" ? "alert-success" :
//           paymentState === "FAILED" ? "alert-danger" : "alert-warning"
//         }`}>
//           Payment Status: {paymentState}
//         </div>
//       )}

//       <div className="card mt-3 p-3">
//         <h5>Available Balance:</h5>
//         <h2>₹{balance}</h2>
//       </div>

//       <button
//         className="btn btn-primary mt-3"
//         onClick={() => setFundpage(true)}
//       >
//         Add Funds
//       </button>

//       {fundpage && (
//         <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
//           <div className="modal-dialog">
//             <div className="modal-content">
//               <form onSubmit={handleSubmitdonate}>
//                 <div className="modal-header">
//                   <h5 className="modal-title">Add Funds</h5>
//                   <button type="button" className="btn-close" onClick={() => setFundpage(false)}></button>
//                 </div>
//                 <div className="modal-body">
//                   <input
//                     type="number"
//                     className="form-control"
//                     placeholder="Enter amount"
//                     value={amount}
//                     onChange={(e) => setAmount(e.target.value)}
//                   />
//                   <div className="mt-3">
//                     {[100, 500, 1000, 2000, 5000].map((amt) => (
//                       <button
//                         type="button"
//                         key={amt}
//                         className={`btn btn-outline-primary me-2 mt-2 ${
//                           selectedAmount === amt ? 'active' : ''
//                         }`}
//                         onClick={() => handleAmountClick(amt)}
//                       >
//                         ₹{amt}
//                       </button>
//                     ))}
//                     <button
//                       type="button"
//                       className="btn btn-outline-secondary mt-2"
//                       onClick={handleCustomAmount}
//                     >
//                       Custom
//                     </button>
//                   </div>
//                 </div>
//                 <div className="modal-footer">
//                   <button type="submit" className="btn btn-success">Pay</button>
//                   <button type="button" className="btn btn-secondary" onClick={() => setFundpage(false)}>Close</button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* <h4 className="mt-4">Recent Transactions</h4>
//       <ul className="list-group mt-2">
//         {transactions.map((txn) => (
//           <li key={txn.id} className="list-group-item d-flex justify-content-between">
//             <div>
//               <strong>{txn.description}</strong>
//               <div className="text-muted small">{txn.date}</div>
//             </div>
//             <div className={txn.type === 'credit' ? 'text-success' : 'text-danger'}>
//               <FontAwesomeIcon
//                 icon={txn.type === 'credit' ? faArrowDown : faArrowUp}
//                 className="me-1"
//               />
//               ₹{txn.amount.toFixed(2)}
//             </div>
//           </li>
//         ))}
//       </ul> */}
//     </div>
//   );
// };

// export default WalletPage;
